/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { ChangePlanRequestBillingCadence } from './changePlanRequestBillingCadence';
import type { ChangePlanRequestPlanSlug } from './changePlanRequestPlanSlug';

export interface ChangePlanRequest {
  plan_slug: ChangePlanRequestPlanSlug;
  seat_count?: number | null;
  billing_cadence?: ChangePlanRequestBillingCadence;
}
